import {
  fetchPendingAllSettlements,
  fetchPreviousSettlements,
  fetchSettledSettlements,
  fetchSettlementLedger,
  fetchSettlementSummary,
  settlementUploadSheets,
} from "../../services/settlementService";
import {
  pendingSettlementsFetched,
  previousSettlementsFetched,
  settledSettlementsFetched,
  settlementLedgerFetched,
  settlementSummaryFetched,
  settlementUploadSheet,
  settlementUploadSheetFailure,
} from "../actions/settlementAction";

import { createAllActionCreators } from "./actionCreatorUtil";

const settlementActionCreators = {
  fetchPendingAllSettlementsAction: {
    service: fetchPendingAllSettlements,
    action: pendingSettlementsFetched,
  },
  fetchSettledSettlementsAction: {
    service: fetchSettledSettlements,
    action: settledSettlementsFetched,
  },
  fetchPreviousSettlementsAction: {
    service: fetchPreviousSettlements,
    action: previousSettlementsFetched,
  },
  fetchSettlementSummaryAction: {
    service: fetchSettlementSummary,
    action: settlementSummaryFetched,
  },
  fetchSettlementLedgerAction: {
    service: fetchSettlementLedger,
    action: settlementLedgerFetched,
  },
  settlementUploadSheetAction: {
    service: settlementUploadSheets,
    action: settlementUploadSheet,
    responseNotification: {
      status: true,
      only: true,
    },
    upload: {
      status: true,
      notificationMessage: "Upload Failed",
      errorAction: settlementUploadSheetFailure,
      errorActionMessage: (err) => (err.error
        ? `${err.message}: ${JSON.stringify(err.error)}`
        : err.message || "Something went wrong"),
    },
  },
};

export const {
  fetchPendingAllSettlementsAction,
  fetchSettledSettlementsAction,
  fetchPreviousSettlementsAction,
  fetchSettlementSummaryAction,
  fetchSettlementLedgerAction,
  settlementUploadSheetAction,
} = createAllActionCreators(settlementActionCreators);
